import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import Discharge from "../Forms/J/Discharge/Discharge"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const DischargeContainer = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [isGettingDischarge, setIsGettingDischarge] = useState(true)

  const toast = useRef()

  useEffect(() => {
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      setIsGettingDischarge(true)
      handleSubmitGet(endpoints.GET_DISCHARGE_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
        organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.DISCHARGE,
      })
        .then((response) => {
          loadCollection(setValues(response.data), INTERVIEW_SECTIONS.DISCHARGE)
          handleLoadPrev(false)
          setIsGettingDischarge(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingDischarge(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_j_1: data?.form?.gpraJ1 ? new Date(data?.form?.gpraJ1) : new Date(),
      gpra_j_2: data?.form?.gpraJ2 ?? "",
      gpra_j_2a: data?.form?.gpraJ2a ?? "",
      gpra_j_2a1: data?.form?.gpraJ2a1 ?? "",
      gpra_j_3: data?.form?.gpraJ3,
      gpra_j_4: data?.form?.gpraJ4,
      gpra_j_5: data?.form?.gpraJ5 ?? "",
      gpra_j_6: data?.form?.gpraJ6 ?? "",
      gpra_j_id: data?.form?.gpraJId ?? 0,
      additional: data?.additional,
    }
  }
  if (isGettingDischarge) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingDischarge && (
        <Discharge showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default DischargeContainer
